import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/Measurements/MeasurementLevel.png";
import PracticeGame from "../../components/MP_PracticeGame";
import Calculator from "../../components/Calculator";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useRatingQuestions from "../../hooks/useRatingQuestions";
import { MultiHook } from "tapable";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function RandomChar() {
  var result = '';
  var characters = 'abcdefghijklmnopqrstuvwxyz';
  var charactersLength = characters.length;
  result = characters.charAt(Math.floor(Math.random() * charactersLength));
  return result;
}

//Generates a question from a default question
function GenQuestion(q) {
  //All the shared variables
  let questionAnswers = [];
  //Add the correct answer
  questionAnswers.push({ correct: true, value: q.right_answer });
  //Add the wrong answers
  questionAnswers.push({ correct: false, value: q.wrong_answer_1 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_2 });
  questionAnswers.push({ correct: false, value: q.wrong_answer_3 });

  shuffleArray(questionAnswers);

  let questionObj = {
    question: q.question_line_1,
    question2: q.question_line_2,
    answers: questionAnswers,
    correct: q.right_answer,
    topic_id: q.topic_id
  };
  return questionObj;
}

export default function Multiplayer({ ...props }) {
  const game = props.game;
  console.log(props);
  const { questions } = useRatingQuestions({ game_type: game.game_type }, game);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([,]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  //const [realQuestions, setRealQuestions] = useState();
  const [workAround, setWorkAround] = useState(false);
  const [place, setPlace] = useState(0);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if (waitTime != -10) {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currentQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);
        if (multiplier != 0 && multiplier != undefined)
          props.SubmitScore(multiplier * 10);


        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currentQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
          props.SubmitScore(-10)
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }

      //Generates a new question
      //newQuestion();

    }
  }

  function GetListOfPositions() {
    //order the scores
    //console.log(props);
    //var web = props.parent.getwebrtc();
    var web = props.ReturnScores();
    console.log(web);
    var webcopy = JSON.parse(JSON.stringify(web));
    // console.log(webcopy);
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    //console.log(webcopy);
    //replace yourname with YOU
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username)
        webcopy[i].username = "You"
    }
    var scoreText = [];
    for (let i = 0; i < webcopy.length; i++) {
      let temptext = webcopy[i].username + ": " + webcopy[i].score
      scoreText.push(temptext);
    }
    // console.log(scoreText);
    const listItems = scoreText.map((i) =>
      <li>{i}</li>
    );

    return listItems;
  }

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    var difficulty = Math.floor(Math.random() * questions.length);
    var questionNum = Math.floor(Math.random() * questions[difficulty].length)
    currQuestion = GenQuestion(questions[difficulty][questionNum]);;
    console.log(questions[difficulty][questionNum])
    console.log(currQuestion);
    setCurrentQuestion(currQuestion);
    return currQuestion;
  }

  function GetPlace() {
    var position = 0;
    //order the scores
    var web = props.ReturnScores();
    var webcopy = JSON.parse(JSON.stringify(web));
    //then order the scores in descending order
    //display them as a list
    webcopy.sort((a, b) => (a.score < b.score) ? 1 : -1)
    console.log(webcopy);
    //gets your position in the list
    for (let i = 0; i < webcopy.length; i++) {
      if (webcopy[i].username == props.details.username) {
        setPlace(i + 1);
        position = i + 1;
      }

    }
    console.log(place);
    console.log(position);
    return position;
  }

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions)
      setCurrentQuestion(newQuestion())
    }
  }, [questions]);

  function ComboImage() {
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
      comboNum = 4;
    var imageName = props.game.animation_path + "/combo" + comboNum + ".gif";
    //return <img src= {{imageName}} style={{position:"relative"}}></img>
    console.log("../../assets/" + imageName)

    return (require("../../assets/" + imageName))

  }


  return (
    <PracticeGame
      parent={props}
      loading={!questions}
      correct={correctQuestions}
      incorrect={incorrectQuestions}
      score={score}
      onBack={() => props.onBack()}
      defaultTimer={60}
      restart={() => {
        setCombo(0);
        setScore(0);
        setCorrectQuestions([]);
        setIncorrectQuestions([]);
      }}
      feedback={feedback}
      homework_id={props.homework_id}
      getplace={() => GetPlace()}
    >
      <div style={{ backgroundImage: `url(${ComboImage()})`, backgroundSize: "cover", height: "100%" }} >
        <Body>
          <FormContent style={{ right: "100px", top: "0px", width: "200px", height: "50%" }}>
            <br></br>
            {GetListOfPositions()}
          </FormContent>
          <div>{currQuestion !== undefined ? (


            <Container>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Question
                  type="text"
                  disabled
                  javaScriptEnabled={true}
                  //I don't know if this does anything
                  value={
                    currQuestion.question !== undefined
                      ? <div dangerouslySetInnerHTML={((currQuestion.question.replace("$", "?")))} />
                      : ""
                  }
                >
                  <div dangerouslySetInnerHTML={{ __html: (currQuestion.question) }} />
                </Question>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Question
                  type="text"
                  disabled
                  javaScriptEnabled={true}
                  //I don't know if this does anything
                  value={
                    currQuestion.question2 !== undefined
                      ? <div dangerouslySetInnerHTML={((currQuestion.question2.replace("$", "?")))} />
                      : ""
                  }
                >
                  <div dangerouslySetInnerHTML={{ __html: (currQuestion.question2) }} />
                </Question>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}
              >
                {showColouredFeedback == false && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" }}
                      onClick={() => checkResult(answer, true)}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}

                {showColouredFeedback == true && currQuestion.answers !== undefined &&
                  currQuestion.answers.map(answer => (
                    <Button
                      value={<div dangerouslySetInnerHTML={answer.value} />}
                      style={{ flex: 1, margin: "20px" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                    >
                      <span>{<div dangerouslySetInnerHTML={{ __html: (answer.value) }} />}</span>
                    </Button>
                  ))}
              </div>
            </Container>

          ) : <h1>help</h1>}
          </div>
          <Combo>
            <span style={{ fontSize: "50px" }}>{combo}</span>
            <span style={{ fontSize: "20px" }}>COMBO</span>
          </Combo>
        </Body>
      </div>
    </PracticeGame>
  );
}

const Body = styled.div`
    width: 100%;
    height: 100%;
    background-image: url(${background});
    background-size: cover;
    background-position: 0px -1px;
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const Result = styled.div`
    width: 100%;
    height: 100%;
    font-size: 5em;
    text-align: center;
    border: solid 2px #683d8c;
`;

const Combo = styled.div`
    background: #4391bb;
    width: 120px;
    height: 120px;
    border-radius: 75px;
    border: solid #204b7b 4px;
    display: flex;
    flex-direction: column;
    text-align: center;
    color: #fff;
    justify-content: center;
    font-weight: 600;
`;

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border: 2px solid #673b8b;
  border-radius: 1em;
  font-size: 2em;

  h1 {
    color: #673b8b;
    font-size: 4em;
    margin: 0.25em;
  }


`;

const Question = styled.div`
  background: #E9E9E9;
  user-select: none;
  width: 40em;
  line-height: 35px;
  font-size: 30px;
  margin: 15px 25px;
  text-align: center;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  padding: 20px 0px 20px;
  `;

const Button = styled.div`
        text-align: center;
        width: 5em;
        line-height: 35px;
        font-size: 3em;
  padding: 35px 0px 35px;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;
